import moment from 'moment';
import React from 'react';

export default function MomentDate({
  date,
  format = 'MM/DD/YYYY',
}: {
  date: string;
  format?: string;
}) {
  const taskDate = moment(date).format(format);

  return <>{taskDate}</>;
}
